// コンバートエラーモーダル
const ModalConvertError = {
  namespaced: true,

  state: {
    modal: false,
    modalEditor: false,
    error: {
      room_id: null,
      portal_site: '',
      title: '',
      error: [],
    },
  },
  getters: {
    getModal: state => {
      return state.modal
    },
    getModalEditor: state => {
      return state.modalEditor
    },
    getError: state => {
      return state.error
    },
  },
  mutations: {
    setModal(state, modal) {
      state.modal = modal
    },
    setModalEditor(state, modal) {
      state.modalEditor = modal
    },
    setError(state, error) {
      state.error = error
    },
  },
  actions: {
    set({ commit }, item) {
      commit('setError', item)
      commit('setModal', true)
    },
    reset({ commit }) {
      const error = {
        room_id: null,
        portal_site: '',
        title: '',
        error: [],
      }
      commit('setModal', false)
      commit('setError', error)
    },
  },
}

export default ModalConvertError
